import React, { useContext } from "react";
import { CommandBarButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { OrderListingContext } from "../context/OrderListingContext";
import { MergeOrdersDialog } from "./MergeOrdersDialog";

export const MergeOrdersButton: React.VFC = () => {
    const { mergeListItems, selectedItems } = useContext(OrderListingContext);
    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdReadWrite]}>
            <CommandBarButton
                text="Merge"
                icon="Merge"
                disabled={!(mergeListItems.length === 2 || selectedItems.length === 2)}
                onClick={onOpen}
            />
            <MergeOrdersDialog key={String(isOpen)} isOpen={isOpen} onClose={onClose} />
        </AuthorizationWrapper>
    );
};
